// PA 487087 - espelho no front da regra de domínio TiposOrcamentosExtensions.SuportaMostruario (Domain/Enums/Venda/Enums.cs).
// Fonte única no front: quais tipos de orçamento suportam controle de mostruário.
// Os valores seguem o enum TiposOrcamento do backend (mesma ordem do IOrcamento.TipoOrcamento).
export enum TipoOrcamento {
    Venda = 0,
    OutrasSaidas = 1,
    Transferencias = 2,
    VendaRest = 3,
}

const TIPOS_QUE_SUPORTAM_MOSTRUARIO: TipoOrcamento[] = [
    TipoOrcamento.Venda,
    TipoOrcamento.VendaRest,
    TipoOrcamento.OutrasSaidas, // 491365 - mostruário também para Outras Saídas
]

export function tipoOrcamentoSuportaMostruario(tipoOrcamento: TipoOrcamento | null | undefined): boolean {
    return tipoOrcamento != null && TIPOS_QUE_SUPORTAM_MOSTRUARIO.includes(tipoOrcamento)
}
